import React from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../../styled-components/dark';
import LineUpFormula1PitStopSvgAsComponent from '../../assets/asComponents/LineUpFormula1PitStopSvgAsComponent';

type WrapperType = {
  $isEnded: boolean;
};

const Wrapper = styled.div<WrapperType>`
  ${({ $isEnded }) => {
    if ($isEnded) {
      return css`
        --LineUpPitStop-color: ${theme.LineUpPitStop.ended.color};
      `;
    }
    return css`
      --LineUpPitStop-color: ${theme.LineUpPitStop.default.color};
    `;
  }}

  display: flex;
  justify-content: center;
`;

const StyledPitStopIcon = styled(LineUpFormula1PitStopSvgAsComponent)`
  width: 1em;
`;

const PitstopCount = styled.div`
  margin-left: 0.2em;
  font-size: 0.9em;
  color: var(--LineUpPitStop-color);
`;

type LineUpPitStopPropsType = {
  className?: string;
  isEnded?: boolean;
  count?: number;
};

const LineUpPitStop = ({ className = '', isEnded = false, count = 0 }: LineUpPitStopPropsType) => {
  return count ? (
    <Wrapper className={className} $isEnded={isEnded}>
      <StyledPitStopIcon isEnded={isEnded} />
      <PitstopCount>x{count}</PitstopCount>
    </Wrapper>
  ) : null;
};

export default LineUpPitStop;
